import { io } from "socket.io-client";
import { initLectureChatState } from "./chat.inits";

/** @type {(import("vuex").Module<import("./chat.inits").LectureChatState>)} */
export const chat = {
    namespaced: true,

    state: initLectureChatState(),

    mutations: {
        setCount(state, count) {
            state.count = count;
        },
        setHeight(state, height) {
            state.height = height;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        setWatchers(state, watchers) {
            state.watchers = watchers;
        },
        pushMessage(state, message) {
            state.messages.push(message);
        },
    },

    actions: {
        async init({ state, rootState, dispatch }) {
            if (!state.socket) {
                if (state.loading) commit("setLoading", true);

                const { accessToken } = rootState;

                /** @type {Partial<import("socket.io-client").ManagerOptions & import("socket.io-client").SocketOptions>} */
                let options = {
                    path: "/socket",
                    transports: ["websocket"],
                    auth: { accessToken },
                };

                if (!accessToken) delete options.auth.accessToken;

                state.socket = io("/lecture", options);
                state.socket.on("chat", (payload) => dispatch("onChat", payload));
                state.socket.on("noti", (payload) => dispatch("onNoti", payload));
                state.socket.on("inited", (payload) => dispatch("onInited", payload));
                state.socket.on("joined", (payload) => dispatch("onJoined", payload));
                state.socket.on("chatted", (payload) => dispatch("onChatted", payload));
                state.socket.on("count", (payload) => dispatch("onCount", payload));
                state.socket.on("watchers", (payload) => dispatch("onWatchers", payload));
            }
        },

        async onInited({ state, commit, dispatch }, { success }) {
            if (state.loading) commit("setLoading", false);
            if (success) dispatch("join");
        },
        async join({ state, rootState, commit }) {
            if (state.loading) return;
            else commit("setLoading", true);

            const { _lecture } = rootState.lecture;
            state.socket.emit("join", { _lecture });
        },
        async onJoined({ state, commit }, { success }) {
            if (state.loading) commit("setLoading", false);

            if (success) {
                commit("pushMessage", {
                    type: "noti",
                    message: "방에 입장하셨습니다",
                });
            }
        },

        async chat({ state, rootState, commit }, message) {
            if (state.loading) return;
            else commit("setLoading", true);

            const { _lecture } = rootState.lecture;
            state.socket.emit("chat", { _lecture, message });
        },
        async onChatted({ state, commit }, { success, message, createdAt }) {
            if (state.loading) commit("setLoading", false);
            if (success) commit("pushMessage", { type: "user", message, createdAt });
        },

        async onChat({ rootState, commit }, { _lecture, ...message }) {
            if (rootState.lecture._lecture == _lecture) {
                commit("pushMessage", message);
            }
        },
        async onNoti({ rootState, commit }, { _lecture, ...message }) {
            if (rootState.lecture._lecture == _lecture) {
                commit("pushMessage", message);
            }
        },
        async onCount({ rootState, commit }, { _lecture, count = 0 }) {
            if (rootState.lecture._lecture == _lecture) {
                commit("setCount", count);
            }
        },
        async onWatchers({ rootState, commit }, { _lecture, watchers }) {
            if (rootState.lecture._lecture == _lecture) {
                commit("setWatchers", watchers);
            }
        },

        async exit({ state, commit }) {
            state.socket.disconnect();
            state.socket = null;
            state.count = 0;
            state.messages = [];
            state.watchers = [];
            state.loading = false;
        },
    },

    modules: {},
};
